export const INPUT_FONT_CLASS = 'text-[16px] sm:text-sm';
